import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ConfirmButtons } from '@app/shared/types';
import { isFunction } from 'lodash';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xea-footer-buttons',
  templateUrl: './footer-buttons.component.html',
  styleUrls: ['./footer-buttons.component.scss'],
  standalone: false,
})
export class FooterButtonsComponent implements OnInit {
  @Input() public buttons: ConfirmButtons[] = [];

  public constructor() {}

  public ngOnInit(): void {}

  public btnClick(button: ConfirmButtons) {
    if (isFunction(button.click)) {
      button.click();
    }
  }
}
